<div class="accordion-item-header" (click)="toggle()">
  <ng-content select="[header]" />
  @if (showChevron()) {
    <fa-icon class="chevron-icon" [icon]="faChevronDown" />
  }
</div>
<div class="accordion-item-content">
  <div class="accordion-item-content-wrapper">
    <div class="accordion-item-content-inner">
      <ng-content select="[content]" />
    </div>
  </div>
</div>
